import React, { useRef } from 'react';
import { useAuth } from '../../context/AuthContext';
import { useEditMode } from '../../context/EditModeContext';
import { useContent } from '../../context/ContentContext';
import { promptImageUrl, readImageFile } from '../../utils/imageUpload';
import './editable.css';

export default function EditableBackground({
  contentKey,
  src,
  className = '',
  children,
  style = {},
  ...rest
}) {
  const { isEditing } = useAuth();
  const { controlsVisible, activeFieldKey } = useEditMode();
  const showToolbar = controlsVisible || activeFieldKey === contentKey;
  const { getContent, setContentValue, clearContentValue } = useContent();
  const fileInputRef = useRef(null);

  const displaySrc = getContent(contentKey, src);
  const mergedStyle = {
    ...style,
    backgroundImage: `url(${displaySrc})`,
  };

  const applyImage = async (file) => {
    try {
      const dataUrl = await readImageFile(file);
      setContentValue(contentKey, dataUrl);
    } catch (error) {
      window.alert(error.message);
    }
  };

  if (!isEditing) {
    return (
      <div className={className} style={mergedStyle} {...rest}>
        {children}
      </div>
    );
  }

  return (
    <div
      className={`editable-background ${className}`}
      style={mergedStyle}
      data-content-key={contentKey}
      {...rest}
    >
      {children}
      {showToolbar && (
      <span className="editable-image-toolbar editable-image-toolbar--background" role="toolbar" aria-label="Background image editing tools">
        <button type="button" className="editable-image-btn" onClick={() => fileInputRef.current?.click()}>
          Replace background
        </button>
        <button
          type="button"
          className="editable-image-btn"
          onClick={() => {
            const url = promptImageUrl();
            if (url) setContentValue(contentKey, url);
          }}
        >
          URL
        </button>
        <button
          type="button"
          className="editable-image-btn editable-image-btn--danger"
          onClick={() => {
            if (window.confirm('Reset this background to the original?')) {
              clearContentValue(contentKey);
            }
          }}
        >
          Reset
        </button>
      </span>
      )}
      <input
        ref={fileInputRef}
        type="file"
        accept="image/*"
        className="editable-image-input"
        onChange={(e) => {
          const file = e.target.files?.[0];
          if (file) applyImage(file);
          e.target.value = '';
        }}
      />
    </div>
  );
}
